// import React, { useState, useRef, useEffect } from "react";
// import {
//   Form,
//   Table,
//   notification,
//   Tooltip,
//   Popconfirm,
// } from "../../components/Elements/appUtils";
// import PageHeader from "../../components/Elements/pageHeader";
// import axios from "axios";
// import { GetEachFormFields } from "../../components/_utils/formUtils";
// import { useDispatch } from "react-redux";
// import { getToken } from "../../request";

// /*
// IMPORTANT
// Change these API URLs according to your project
// */
// const ADD_MAIN_MENU = "/api/mainMenu/create";
// const LIST_MAIN_MENU = "/api/mainMenu/list";
// const DELETE_MAIN_MENU = "/api/mainMenu/delete";

// function MainMenu(props) {
//   const tableRef = useRef();
//   const dispatch = useDispatch();

//   const [name, setName] = useState("");
//   const [deleted, setDeleted] = useState("false");

//   /*
//   ---------------------------
//   SUBMIT
//   ---------------------------
//   */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     props.form.validateFields(async (err, valData) => {
//       if (err) return;

//       if (!valData.mainMenuName) {
//         notification.warning({ message: "Enter Main Menu Name" });
//         return;
//       }

//       const response = await axios.post(
//         ADD_MAIN_MENU,
//         valData,
//         getToken()
//       );

//       if (response.data.success) {
//         notification.success({
//           message: response.data.message || "Saved",
//         });

//         props.form.setFieldsValue({
//           mainMenuName: "",
//         });

//         tableRef.current.reload();
//       } else {
//         notification.error({
//           message: response.data.message,
//         });
//       }
//     });
//   };

//   /*
//   ---------------------------
//   TABLE API
//   ---------------------------
//   */
//   const apiRequest = (params) => {
//     return new Promise(async (resolve) => {
//       try {
//         if (name) {
//           params.name = name;
//         }

//         if (deleted === "true") {
//           params.deleted = true;
//         } else {
//           params.deleted = { $exists: false };
//         }

//         const { data } = await axios.post(
//           LIST_MAIN_MENU,
//           params,
//           getToken()
//         );

//         resolve(data);
//       } catch (error) {
//         console.log(error);
//       }
//     });
//   };

//   /*
//   ---------------------------
//   DELETE
//   ---------------------------
//   */
//   const deleteMenu = async (id, deleted) => {
//     const resp = await axios.post(
//       DELETE_MAIN_MENU,
//       { id, deleted },
//       getToken()
//     );

//     if (resp.data.success) {
//       tableRef.current.reload();
//     }
//   };

//   /*
//   ---------------------------
//   TABLE COLUMNS
//   ---------------------------
//   */
//   const columns = [
//     {
//       title: "Main Menu Name",
//       dataIndex: "mainMenuName",
//       key: "mainMenuName",
//     },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, item) => (
//         <>
//           {item.deleted !== true ? (
//             <Tooltip title="Delete">
//               <Popconfirm
//                 title="Delete Main Menu?"
//                 okText="Yes"
//                 cancelText="No"
//                 onConfirm={() => deleteMenu(item._id, true)}
//               >
//                 <i
//                   className="fa fa-trash"
//                   style={{ marginLeft: 20 }}
//                 />
//               </Popconfirm>
//             </Tooltip>
//           ) : (
//             <Tooltip title="Undo Delete">
//               <Popconfirm
//                 title="Undo Delete?"
//                 okText="Yes"
//                 cancelText="No"
//                 onConfirm={() => deleteMenu(item._id, false)}
//               >
//                 <i
//                   className="fa fa-undo"
//                   style={{ marginLeft: 20 }}
//                 />
//               </Popconfirm>
//             </Tooltip>
//           )}
//         </>
//       ),
//     },
//   ];

//   /*
//   ---------------------------
//   FORM FIELDS
//   ---------------------------
//   */
//   const inputTypes = {
//     fields: [
//       {
//         key: "mainMenuName",
//         label: "Main Menu Name",
//         span: "col-md-4",
//         placeholder: "Enter Main Menu Name",
//         type: "text",
//       },
//     ],
//   };

//   const search = () => {
//     tableRef.current.reload();
//   };

//   return (
//     <PageHeader title={"Main Menu"}>
//       {/* FORM */}
//       <Form onSubmit={handleSubmit}>
//         <div className="card">
//           <div className="card-body">
//             <div className="row">
//               {inputTypes.fields.map((item, key) => (
//                 <div className={item.span} key={key}>
//                   <GetEachFormFields {...props.form} item={item} />
//                 </div>
//               ))}
//             </div>

//             <button className="btn btn-success">
//               SUBMIT
//             </button>
//           </div>
//         </div>
//       </Form>

//       {/* SEARCH */}
//       <div className="row mb-3 mt-3">
//         <div className="col-md-3">
//           <input
//             className="form-control"
//             placeholder="Search Menu"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//           />
//         </div>

//         <div className="col-md-2">
//           <select
//             className="form-control"
//             value={deleted}
//             onChange={(e) => {
//               setDeleted(e.target.value);
//               setTimeout(() => {
//                 tableRef.current.reload();
//               }, 300);
//             }}
//           >
//             <option value="false">Not Deleted</option>
//             <option value="true">Deleted</option>
//           </select>
//         </div>

//         <div className="col-md-2">
//           <button
//             className="btn btn-info"
//             onClick={search}
//           >
//             Search
//           </button>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="card">
//         <div className="card-body">
//           <Table
//             apiRequest={apiRequest}
//             columns={columns}
//             ref={tableRef}
//           />
//         </div>
//       </div>
//     </PageHeader>
//   );
// }

// export default Form.create()(MainMenu);




// import React, { useState, useRef } from "react";
// import {
//   Form,
//   Table,
//   notification,
//   Tooltip,
//   Popconfirm,
// } from "../../components/Elements/appUtils";
// import PageHeader from "../../components/Elements/pageHeader";
// import axios from "axios";
// import { GetEachFormFields } from "../../components/_utils/formUtils";
// import { useDispatch } from "react-redux";
// import { getToken } from "../../request";

// import {
//   addMainMenuUrl,
//   getMainMenuUrl,
//   deleteMainMenuUrl
// } from "./api";

// function MainMenu(props) {

//   const tableRef = useRef();
//   const dispatch = useDispatch();

//   const [name, setName] = useState("");
//   const [deleted, setDeleted] = useState("false");
//   const [editId, setEditId] = useState(null);
// const [isEdit, setIsEdit] = useState(false);

//   /*
//   ==========================================
//   SUBMIT MAIN MENU
//   ==========================================
//   */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     props.form.validateFields(async (err, valData) => {
//       if (err) return;

//       if (!valData.mainMenuName) {
//         notification.warning({ message: "Enter Main Menu Name" });
//         return;
//       }

//       try {
//         const response = await axios.post(
//           addMainMenuUrl(),
//           valData,
//           getToken()
//         );

//         if (response.data.success) {

//           notification.success({
//             message: response.data.message || "Saved Successfully",
//           });

//           props.form.setFieldsValue({
//             mainMenuName: ""
//           });

//           tableRef.current.reload();

//         } else {
//           notification.error({
//             message: response.data.message
//           });
//         }

//       } catch (error) {
//         console.log(error);
//       }

//     });
//   };

//   /*
//   ==========================================
//   TABLE DATA API
//   ==========================================
//   */
//   const apiRequest = async (params) => {

//     try {

//       if (name) {
//         params.name = name;
//       }

//       if (deleted === "true") {
//         params.deleted = true;
//       } else {
//         params.deleted = { $exists: false };
//       }

//       const { data } = await axios.get(
//         getMainMenuUrl(),
//         getToken()
//       );

//       return data;

//     } catch (error) {
//       console.log(error);
//       return { data: [] };
//     }
//   };

//   /*
//   ==========================================
//   DELETE MENU
//   ==========================================
//   */
//   const deleteMenu = async (id) => {
//   try {

//     const resp = await axios.delete(
//       deleteMainMenuUrl(id),
//       getToken()
//     );

//     if (resp.data.success) {
//       tableRef.current.reload();
//     }

//   } catch (error) {
//     console.log(error);
//   }
// };

//   /*
//   ==========================================
//   TABLE COLUMNS
//   ==========================================
//   */
//   const columns = [
//     {
//       title: "Main Menu Name",
//       dataIndex: "mainMenuName",
//       key: "mainMenuName",
//     },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, item) => (
//         <>
//         <i
//         className="fa fa-edit"
//         style={{ cursor: "pointer" }}
//         onClick={() => handleEdit(item)}
//       />
// </i>
//           {item.deleted !== true ? (
//             <Tooltip title="Delete">
//               <Popconfirm
//                 title="Delete Main Menu?"
//                 okText="Yes"
//                 cancelText="No"
//                 onConfirm={() => deleteMenu(item._id, true)}
//               >
//                 <i className="fa fa-trash" style={{ marginLeft: 20 }} />
//               </Popconfirm>
//             </Tooltip>
//           ) : (
//             <Tooltip title="Undo Delete">
//               <Popconfirm
//                 title="Undo Delete?"
//                 okText="Yes"
//                 cancelText="No"
//                 onConfirm={() => deleteMenu(item._id, false)}
//               >
//                 <i className="fa fa-undo" style={{ marginLeft: 20 }} />
//               </Popconfirm>
//             </Tooltip>
//           )}
//         </>
//       ),
//     },
//   ];

//   /*
//   ==========================================
//   FORM FIELDS
//   ==========================================
//   */
//   const inputTypes = {
//     fields: [
//       {
//         key: "mainMenuName",
//         label: "Main Menu Name",
//         span: "col-md-4",
//         placeholder: "Enter Main Menu Name",
//         type: "text",
//       },
//     ],
//   };

//   const search = () => {
//     tableRef.current.reload();
//   };

//   /*
//   ==========================================
//   UI
//   ==========================================
//   */
//   return (
//     <PageHeader title={"Main Menu"}>

//       {/* FORM */}
//       <Form onSubmit={handleSubmit}>
//         <div className="card">
//           <div className="card-body">

//             <div className="row">
//               {inputTypes.fields.map((item, key) => (
//                 <div className={item.span} key={key}>
//                   <GetEachFormFields {...props.form} item={item} />
//                 </div>
//               ))}
//             </div>

//             <button className="btn btn-success">
//               SUBMIT
//             </button>

//           </div>
//         </div>
//       </Form>


//       {/* SEARCH */}
//       <div className="row mt-3 mb-3">

//         <div className="col-md-3">
//           <input
//             className="form-control"
//             placeholder="Search Menu"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//           />
//         </div>

//         <div className="col-md-2">
//           <select
//             className="form-control"
//             value={deleted}
//             onChange={(e) => {
//               setDeleted(e.target.value);
//               setTimeout(() => {
//                 tableRef.current.reload();
//               }, 300);
//             }}
//           >
//             <option value="false">Not Deleted</option>
//             <option value="true">Deleted</option>
//           </select>
//         </div>

//         <div className="col-md-2">
//           <button
//             className="btn btn-info"
//             onClick={search}
//           >
//             Search
//           </button>
//         </div>

//       </div>


//       {/* TABLE */}
//       <div className="card">
//         <div className="card-body">
//           <Table
//             ref={tableRef}
//             apiRequest={apiRequest}
//             columns={columns}
//           />
//         </div>
//       </div>

//     </PageHeader>
//   );
// }

// export default Form.create()(MainMenu);







import React, { useState, useRef } from "react";
import {
  Form,
  Table,
  notification,
  Tooltip,
  Popconfirm,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import axios from "axios";
import { GetEachFormFields } from "../../components/_utils/formUtils";
import { useDispatch } from "react-redux";
import { getToken } from "../../request";
import EditMainMenu from "./editMainMenu";

import {
  addMainMenuUrl,
  getMainMenuUrl,
  deleteMainMenuUrl,
  updateMainMenuUrl
} from "./api";

function MainMenu(props) {

  const tableRef = useRef();
  const dispatch = useDispatch();

  /* ------------------ STATES ------------------ */
  const [name, setName] = useState("");
  const [deleted, setDeleted] = useState("false");
  const [status, setStatus] = useState("");

  // const [editId, setEditId] = useState(null);
  // const [isEdit, setIsEdit] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  /* ======================================================
     ADD + UPDATE
  ====================================================== */
//  const handleSubmit = (e) => {
//   e.preventDefault();
//
//   props.form.validateFields(async (err, valData) => {
//     if (err) return;
//     const payload = {
//       ...valData,
//     };
//     // if (!isEdit) {
//     //   payload.status = "Active";
//     // }
//     payload.status = "Active";
//
//     try {
//
//       let response;
//
//       // if (isEdit) {
//       //   response = await axios.put(
//       //     updateMainMenuUrl(editId),
//       //     valData,
//       //     getToken()
//       //   );
//       // } else {
//       //   response = await axios.post(
//       //     addMainMenuUrl(),
//       //     valData,
//       //     getToken()
//       //   );
//       // }
//       // if (isEdit) {
//       //   response = await axios.put(
//       //       updateMainMenuUrl(editId),
//       //       payload,
//       //       getToken()
//       //   );
//       // } else {
//       //   response = await axios.post(
//       //       addMainMenuUrl(),
//       //       payload,
//       //       getToken()
//       //   );
//       // }
//
//       if (response.data.success) {
//
//         notification.success({
//           message: response.data.message || "Success",
//         });
//
//         /* clear form */
//         props.form.resetFields();
//         props.form.setFieldsValue({
//           mainMenuName: ""
//         });
//
//         setIsEdit(false);
//         setEditId(null);
//
//         tableRef.current.reload();
//       }
//
//     } catch (error) {
//       console.log(error);
//     }
//   });
// };
  const handleSubmit = (e) => {
    e.preventDefault();

    props.form.validateFields(async (err, valData) => {
      if (err) return;

      const payload = {
        ...valData,
        status: "Active",
      };

      try {
        const response = await axios.post(
            addMainMenuUrl(),
            payload,
            getToken()
        );

        if (response.data.success) {
          notification.success({
            message: response.data.message || "Success",
          });

          props.form.resetFields();
          props.form.setFieldsValue({
            mainMenuName: "",
          });

          tableRef.current.reload();
        } else {
          notification.error({
            message: response.data.message || "Something went wrong",
          });
        }
      } catch (error) {
        console.log(error);
        notification.error({
          message: error?.response?.data?.message || "Request failed",
        });
      }
    });
  };
  /* ======================================================
     TABLE API (FILTER WORKING)
  ====================================================== */
  const apiRequest = async (params) => {

    try {

      const query = {
        ...params,
        name,
        deleted
      };
      // if(status){
      //   quer.status=status;
      // }
      if (status) {
        query.status = status;
      }

      const { data } = await axios.get(
        getMainMenuUrl(),
        {
          ...getToken(),
          params: query
        }
      );

      return data;

    } catch (error) {
      console.log(error);
      return { data: [] };
    }
  };

  /* ======================================================
     DELETE
  ====================================================== */
  const deleteMenu = async (id) => {
    try {
      const resp = await axios.delete(
          deleteMainMenuUrl(id),
          getToken()
      );

      if (resp?.data?.success) {
        notification.success({
          message: resp.data.message || "Deleted successfully",
        });
        tableRef.current.reload();
      } else {
        notification.error({
          message: resp?.data?.message || "Delete failed",
        });
      }
    } catch (error) {
      console.log("DELETE ERROR =>", error);
      console.log("BACKEND RESPONSE =>", error?.response?.data);

      notification.error({
        message: error?.response?.data?.message || "Delete failed",
      });
    }
  };
  const updateMenuStatus = async (item) => {
    try {
      const nextStatus = item.status === "Active" ? "Inactive" : "Active";

      const resp = await axios.put(
          updateMainMenuUrl(item._id),
          {
            mainMenuName: item.mainMenuName,
            status: nextStatus,
          },
          getToken()
      );

      if (resp?.data?.success) {
        notification.success({
          message: resp.data.message || "Status updated successfully",
        });
        tableRef.current.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const setDefaultMenu = async (item) => {
    try {
      const resp = await axios.put(
          updateMainMenuUrl(item._id),
          {
            mainMenuName: item.mainMenuName,
            isDefault: true,
          },
          getToken()
      );

      if (resp?.data?.success) {
        notification.success({
          message: resp.data.message || "Default menu updated successfully",
        });
        tableRef.current.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* ======================================================
     EDIT
  ====================================================== */
  // const handleEdit = (item) => {
  //
  //   setEditId(item._id);
  //   setIsEdit(true);
  //
  //   props.form.setFieldsValue({
  //     mainMenuName: item.mainMenuName
  //   });
  // };
  const handleEdit = (item) => {
    setEditData(item);
    setDrawerOpen(true);
  };
  const closeDrawer = () => {
    setDrawerOpen(false);
    setEditData(null);
  };

  /* ======================================================
     TABLE COLUMNS
  ====================================================== */
  const columns = [
    {
      title: "Main Menu Name",
      dataIndex: "mainMenuName",
      key: "mainMenuName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, item) => {
        return (
            <div className="d-flex align-items-center">
              {status === "Active" ? (
                  <label className="label label-success label-style">Active</label>
              ) : (
                  <label className="label label-danger label-style">Inactive</label>
              )}

              <Tooltip title={status === "Active" ? "Disable Main Menu" : "Enable Main Menu"}>
                <Popconfirm
                    title={status === "Active" ? "Disable Main Menu?" : "Enable Main Menu?"}
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => {
                      if (item.isDefault && status === "Active") {
                        notification.warning({
                          message: "Default menu cannot be disabled",
                        });
                        return;
                      }

                      updateMenuStatus(item);
                    }}
                >
                  <a
                      className={`btn btn-sm ${status === "Active" ? "btn-warning" : "btn-success"}`}
                      style={{ marginLeft: 10 }}
                  >
                    {status === "Active" ? "Disable" : "Enable"}
                  </a>
                </Popconfirm>
              </Tooltip>
            </div>
        );
      },
    },
    {
      title: "Default",
      dataIndex: "isDefault",
      key: "isDefault",
      render: (isDefault, item) => {
        if (isDefault) {
          return <label className="label label-info label-style">Default</label>;
        }

        if (item.status === "Active") {
          return (
              <Tooltip title="Set Default">
                <Popconfirm
                    title="Set this Main Menu as default?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => setDefaultMenu(item)}
                >
                  <a className="btn btn-sm btn-primary">Set Default</a>
                </Popconfirm>
              </Tooltip>
          );
        }

        return <span>—</span>;
      },
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, item) => (
    //     <>
    //       {/* EDIT */}
    //       <Tooltip title="Edit">
    //         <i
    //           className="fa fa-edit"
    //           style={{ cursor: "pointer" }}
    //           onClick={() => handleEdit(item)}
    //         />
    //       </Tooltip>
    //
    //       {/* DELETE */}
    //       <Tooltip title="Delete">
    //         <Popconfirm
    //           title="Delete Main Menu?"
    //           okText="Yes"
    //           cancelText="No"
    //           onConfirm={() => deleteMenu(item._id)}
    //         >
    //           <i
    //             className="fa fa-trash"
    //             style={{ marginLeft: 20, cursor: "pointer" }}
    //           />
    //         </Popconfirm>
    //       </Tooltip>
    //     </>
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, item) => (
          <div className="d-flex align-items-center">
            <Tooltip title="Edit">
              <a
                  className="empty_btn"
                  onClick={() => handleEdit(item)}
              >
                <i className="fa fa-edit" />
              </a>
            </Tooltip>

            <Tooltip title="Delete">
              <Popconfirm
                  title="Delete Main Menu?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => deleteMenu(item._id)}
              >
                <a className="empty_btn ml-2">
                  <i className="fa fa-trash" />
                </a>
              </Popconfirm>
            </Tooltip>
          </div>
      ),
    },
  ];

  /* ======================================================
     FORM FIELD
  ====================================================== */
  const inputTypes = {
    fields: [
      {
        key: "mainMenuName",
        label: "Main Menu Name",
        span: "col-md-4",
        placeholder: "Enter Main Menu Name",
        type: "text",
        required:true,
      },
    ],
  };

  const search = () => {
    tableRef.current.reload();
  };

  /* ======================================================
     UI
  ====================================================== */
  return (
    <PageHeader title={"Main Menu"}>

      {/* FORM */}
      <Form onSubmit={handleSubmit}>
        <div className="card">
          <div className="card-body">

            <div className="row">
              {inputTypes.fields.map((item, key) => (
                <div className={item.span} key={key}>
                  <GetEachFormFields {...props.form} item={item} />
                </div>
              ))}
            </div>

            {/*/!* BUTTON *!/*/}
            {/*<button className="btn btn-success">*/}
            {/*  {isEdit ? "UPDATE" : "SUBMIT"}*/}
            {/*</button>*/}
            <button className="btn btn-success">
              SUBMIT
            </button>

          </div>
        </div>
      </Form>

      {/* SEARCH FILTER */}
      {/*<div className="row mt-3 mb-3">*/}

      {/*  <div className="col-md-3">*/}
      {/*    <input*/}
      {/*      className="form-control"*/}
      {/*      placeholder="Search Menu"*/}
      {/*      value={name}*/}
      {/*      onChange={(e) => setName(e.target.value)}*/}
      {/*    />*/}
      {/*  </div>*/}

      {/*  <div className="col-md-2">*/}
      {/*    <select*/}
      {/*      className="form-control"*/}
      {/*      value={deleted}*/}
      {/*      onChange={(e) => setDeleted(e.target.value)}*/}
      {/*    >*/}
      {/*      <option value="false">Not Deleted</option>*/}
      {/*      <option value="true">Deleted</option>*/}
      {/*    </select>*/}
      {/*  </div>*/}

      {/*  <div className="col-md-2">*/}
      {/*    <button*/}
      {/*      className="btn btn-info"*/}
      {/*      onClick={search}*/}
      {/*    >*/}
      {/*      Search*/}
      {/*    </button>*/}
      {/*  </div>*/}

      {/*</div>*/}
      <div className="row mt-3 mb-3">

        <div className="col-md-3">
          <input
              className="form-control"
              placeholder="Search Menu"
              value={name}
              onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <select
              className="form-control"
              value={deleted}
              onChange={(e) => setDeleted(e.target.value)}
          >
            <option value="false">Not Deleted</option>
            <option value="true">Deleted</option>
          </select>
        </div>

        <div className="col-md-2">
          <select
              className="form-control"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div className="col-md-2">
          <button
              className="btn btn-info"
              onClick={search}
          >
            Search
          </button>
        </div>

      </div>

      {/* TABLE */}
      <div className="card">
        <div className="card-body">
          <Table
            ref={tableRef}
            apiRequest={apiRequest}
            columns={columns}
          />
        </div>
      </div>
      <EditMainMenu
          visible={drawerOpen}
          editData={editData}
          onClose={closeDrawer}
          reloadTable={() => {
            tableRef.current.reload();
          }}
      />
    </PageHeader>
  );
}

export default Form.create()(MainMenu);
